<template>
  <p class="ff-display fw-normal fz-base" data-comp="a-mono-label">
    <slot />
  </p>
</template>
